import { HYPERSCENE_PACKAGE_FEATURE_ENABLED, HYPERSCENE_PACKAGE_NAME } from '../constants/hyperscene-package.const';
import { HyperscenePackageState } from '../models/hyperscene-package-state.interface';
import { HyperscenePackageAdapter } from './hyperscene-package-adapter.interface';

export class HyperscenePackageAdapterService implements HyperscenePackageAdapter {
  public async probePackage(): Promise<HyperscenePackageState> {
    if (!HYPERSCENE_PACKAGE_FEATURE_ENABLED) {
      return {
        health: 'fallback',
        packageName: HYPERSCENE_PACKAGE_NAME,
        packageVersion: null,
        message: 'Package integration is disabled by feature flag.',
      };
    }

    try {
      await import('@sibe/hyperscene');
      const packageName: string = HYPERSCENE_PACKAGE_NAME;
      const packageVersion: string | null = null;

      return {
        health: 'ready',
        packageName,
        packageVersion,
        message: packageVersion === null ? 'Package loaded without version metadata.' : 'Package is available.',
      };
    } catch {
      return {
        health: 'error',
        packageName: HYPERSCENE_PACKAGE_NAME,
        packageVersion: null,
        message: 'Package import failed. Fallback mode is active.',
      };
    }
  }
}
